// import React, { useEffect, useState } from 'react';
// import '../Sidebar/Sidebar.css';
// import Sidebar from '../Sidebar/Sidebar';
// import Header from '../Header/Header';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import '@fortawesome/fontawesome-free/css/all.min.css';
// import axios from 'axios';
// import './PC.css'



// const ProductCategory = () => {



//     const [categoryName, setCategoryName] = useState('');
//     const [categories, setCategories] = useState([]);



//     const [entriesPerPage, setEntriesPerPage] = useState(10);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [loading, setLoading] = useState(true); 
//     const [error, setError] = useState(null); 




//          const fetchCategory = async () => {
//                 try {
//                   const response = await axios.get('https://posapi.emedha.in/api/category');
//                   setCategories(response.data);  // Set users data from API response
//                   setLoading(false);         // Stop loading once data is fetched
//                 } catch (err) {
//                   setError('Error fetching users');  // Handle errors
//                   setLoading(false);
//                 }
//               };

//     console.log(categories)

//         useEffect(() => {
//             fetchCategory();

//         }, []);


//     const handleCategoryChange = (event) => {
//         setCategoryName(event.target.value);
//     };

//     const handleSubmit = (event) => {
//         event.preventDefault();
//         if (categoryName) {
//             const newCategory = { id: categories.length + 7, name: categoryName };
//             setCategories([...categories, newCategory]);
//             setCategoryName('');
//         }
//     };

//     const handleSearchChange = (event) => {
//         setSearchTerm(event.target.value);
//     };

//     const filteredCategories = categories.filter((category) =>
//         category.cat_name && category.cat_name.trim().toLowerCase().includes(searchTerm.toLowerCase())
//       );







//     return (
//         <>
//             <Sidebar />
//             <div id="main">






//                 <div className="container mt-4">
//                     <div className="row">
//                         {/* Category Input */}
//                         <div className="col-md-4">
//                             <div className="card">
//                                 <div className="card-header">Category Name</div>
//                                 <div className="card-body">
//                                     <form onSubmit={handleSubmit}>
//                                     <div className="floating-label-container">
//                                         <input
//                                             type="text"
//                                             className=" floating-input"
//                                             id="categoryName"
//                                             value={categoryName}
//                                             onChange={handleCategoryChange}
//                                             placeholder=" "
//                                         />
//                                         <label htmlFor="categoryName" className="floating-label">
//                                             Enter Category
//                                         </label>
//                                     </div>
//                                     <button type="submit" className="btn btn-primary">
//                                         Submit
//                                     </button>
//                                 </form>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Category List */}
//                     <div className="col-md-8">
//                         <div className="card">
//                             <div className="card-header">Category List</div>
//                             <div className="card-body">
//                                 <div className="row mb-3">
//                                     <div className="col-md-6">
//                                         <label>
//                                             Show
//                                             <select
//                                                 className="custom-select custom-select-sm form-control form-control-sm"
//                                                 style={{ width: 'auto', display: 'inline-block' }}
//                                                 value={entriesPerPage}
//                                                 onChange={(e) => setEntriesPerPage(Number(e.target.value))}
//                                             >
//                                                 <option value="10">10</option>
//                                                 <option value="25">25</option>
//                                                 <option value="50">50</option>
//                                                 <option value="100">100</option>
//                                             </select>
//                                             entries
//                                         </label>
//                                     </div>
//                                     <div className="col-md-6 text-right">
//                                         <label>
//                                             Search:
//                                             <input
//                                                 type="search"
//                                                 className="form-control form-control-sm"
//                                                 value={searchTerm}
//                                                 onChange={handleSearchChange}
//                                             />
//                                         </label>
//                                     </div>
//                                 </div>

//                                 <table className="table table-bordered table-hover">
//                                     <thead>
//                                         <tr>
//                                             <th>No</th>
//                                             <th>Category Name</th>
//                                             <th>Action</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                     {filteredCategories.map((category, index) => ( 
//                                             <tr key={category.id}>
//                                                 <td>{index+1}</td>
//                                                 <td>{category.cat_name}</td>
//                                                 <td>
//                                                     <button className="btn btn-info btn-sm">
//                                                         <i className="fas fa-edit"></i>
//                                                     </button>
//                                                     <button className="btn btn-danger btn-sm ml-2">
//                                                         <i className="fas fa-trash"></i>
//                                                     </button>
//                                                 </td>
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>

//                                 <div className="row">
//                                     <div className="col-md-6">
//                                         <p>
//                                             Showing 1 to {filteredCategories.slice(0, entriesPerPage).length} of{' '}
//                                             {filteredCategories.length} entries
//                                         </p>
//                                     </div>
//                                     <div className="col-md-6">
//                                         <nav>
//                                             <ul className="pagination">
//                                                 <li className="page-item disabled">
//                                                     <a className="page-link" href="#" tabIndex="-1">
//                                                         Previous
//                                                     </a>
//                                                 </li>
//                                                 <li className="page-item active">
//                                                     <a className="page-link" href="#">
//                                                         1
//                                                     </a>
//                                                 </li>
//                                                 <li className="page-item">
//                                                     <a className="page-link" href="#">
//                                                         Next
//                                                     </a>
//                                                 </li>
//                                             </ul>
//                                         </nav>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div >
//     </>
//   );
// };

// export default ProductCategory;



// import React, { useEffect, useState } from 'react';
// import '../Sidebar/Sidebar.css';
// import Sidebar from '../Sidebar/Sidebar';
// import Header from '../Header/Header';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import '@fortawesome/fontawesome-free/css/all.min.css';
// import axios from 'axios';
// import './PC.css';

// const ProductCategory = () => {
//     const [categoryName, setCategoryName] = useState('');
//     const [categories, setCategories] = useState([]);
//     const [entriesPerPage, setEntriesPerPage] = useState(5); // Set to 5 entries per page
//     const [searchTerm, setSearchTerm] = useState('');
//     const [loading, setLoading] = useState(true);
//     const [message, setMessage] = useState(null);
//     const [error, setError] = useState(null);
//     const [currentPage, setCurrentPage] = useState(1); // Track the current page

//     const fetchCategory = async () => {
//         try {
//             const response = await axios.get('https://posapi.emedha.in/api/category');
//             setCategories(response.data);
//             setLoading(false);
//         } catch (err) {
//             setError('Error fetching categories');
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchCategory();
//     }, []);

//     const handleCategoryChange = (event) => {
//         setCategoryName(event.target.value);
//     };



//     const handleSearchChange = (event) => {
//         setSearchTerm(event.target.value);
//     };

//     // Filter categories based on search term
//     const filteredCategories = categories.filter((category) =>
//         category.cat_name && category.cat_name.trim().toLowerCase().includes(searchTerm.toLowerCase())
//     );

//     // Get total pages based on filtered categories and entries per page
//     const totalPages = Math.ceil(filteredCategories.length / entriesPerPage);

//     // Get the categories to display for the current page
//     const currentCategories = filteredCategories.slice(
//         (currentPage - 1) * entriesPerPage,
//         currentPage * entriesPerPage
//     );

//     // Handle page click
//     const handlePageClick = (pageNumber) => {
//         setCurrentPage(pageNumber);
//     };




//     const handleSubmit = async (event) => {
//         event.preventDefault();

//         if (!categoryName.trim()) {
//             alert('Category name is required');
//             return;
//         }

//         try {
//             // Send POST request to the backend to insert a new category
//             const response = await axios.post('https://posapi.emedha.in/api/post/category', {
//                 cat_name: categoryName.trim(), // Send the category name as a POST parameter
//             });

//             // Handle successful response
//             setMessage(response.data.message); // Display success message
//             setCategories([...categories, { cat_name: categoryName.trim() }]); // Update categories list

//             // Clear the input field
//             setCategoryName('');
//         } catch (err) {
//             console.error('Error adding category:', err);
//             setError('Error adding category'); // Display error message if request fails
//         }
//     };


//     const handleDelete = async (catId) => {
//         try {
//             const response = await axios.delete(`https://posapi.emedha.in/api/delete/category/${catId}`);
//             alert(response.data.message);  // Show success message
//             fetchCategory();  // Reload the categories
//         } catch (err) {
//             alert('Error deleting category');
//             console.error(err);
//         }
//     };
//     const handleUpdate = async (catId, updatedCategoryName) => {
//         try {
//             const response = await axios.put(`https://posapi.emedha.in/api/update/category/${catId}`, {
//                 cat_name: updatedCategoryName,
//             });
//             alert(response.data.message);  // Show success message
//             fetchCategory();  // Reload the categories
//         } catch (err) {
//             alert('Error updating category');
//             console.error(err);
//         }
//     };



//     return (
//         <>
//             <Sidebar />
//             <div id="main">
//                 <div className="container mt-4">
//                     <div className="row">
//                         {/* Category Input */}
//                         <div className="col-md-4">
//                             <div className="card">
//                                 <div className="card-header">Category Name</div>
//                                 <div className="card-body">
//                                     <form onSubmit={handleSubmit}>
//                                         <div className="floating-label-container">
//                                             <input
//                                                 type="text"
//                                                 className="floating-input"
//                                                 id="categoryName"
//                                                 value={categoryName}
//                                                 onChange={handleCategoryChange}
//                                                 placeholder=" "
//                                             />
//                                             <label htmlFor="categoryName" className="floating-label">
//                                                 Enter Category
//                                             </label>
//                                         </div>
//                                         <button type="submit" className="btn btn-primary">
//                                             Submit
//                                         </button>
//                                     </form>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Category List */}
//                         <div className="col-md-8">
//                             <div className="card">
//                                 <div className="card-header">Category List</div>
//                                 <div className="card-body">
//                                     <div className="row mb-3">
//                                         <div className="col-md-6">
//                                             <label>
//                                                 Show
//                                                 <select
//                                                     className="custom-select custom-select-sm form-control form-control-sm"
//                                                     style={{ width: 'auto', display: 'inline-block' }}
//                                                     value={entriesPerPage}
//                                                     onChange={(e) => setEntriesPerPage(Number(e.target.value))}
//                                                 >
//                                                     <option value="5">5</option>
//                                                     <option value="10">10</option>
//                                                     <option value="25">25</option>
//                                                     <option value="50">50</option>
//                                                 </select>
//                                                 entries
//                                             </label>
//                                         </div>
//                                         <div className="col-md-6 text-right">
//                                             <label>
//                                                 Search:
//                                                 <input
//                                                     type="search"
//                                                     className="form-control form-control-sm"
//                                                     value={searchTerm}
//                                                     onChange={handleSearchChange}
//                                                 />
//                                             </label>
//                                         </div>
//                                     </div>

//                                     <table className="table table-bordered table-hover">
//                                         <thead>
//                                             <tr>
//                                                 <th>No</th>
//                                                 <th>Category Name</th>
//                                                 <th>Action</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {currentCategories.map((category, index) => (
//                                                 <tr key={category.id}>
//                                                     <td>{(currentPage - 1) * entriesPerPage + index + 1}</td>
//                                                     <td>{category.cat_name}</td>
//                                                     <td>
//                                                         <button
//                                                             className="btn btn-info btn-sm"
//                                                             onClick={() => handleUpdate(category.cat_id, 'New Category Name')}
//                                                         >
//                                                             <i className="fas fa-edit"></i>
//                                                         </button>
//                                                         <button
//                                                             className="btn btn-danger btn-sm ml-2"
//                                                             onClick={() => handleDelete(category.cat_id)}
//                                                         >
//                                                             <i className="fas fa-trash"></i>
//                                                         </button>
//                                                     </td>
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>

//                                     {/* Pagination Controls */}
//                                     <div className="row">
//                                         <div className="col-md-6">
//                                             <p>
//                                                 Showing {(currentPage - 1) * entriesPerPage + 1} to{' '}
//                                                 {Math.min(currentPage * entriesPerPage, filteredCategories.length)} of {filteredCategories.length} entries
//                                             </p>
//                                         </div>
//                                         <div className="col-md-6">
//                                             <nav>
//                                                 <ul className="pagination">
//                                                     <li
//                                                         className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}
//                                                     >
//                                                         <a
//                                                             className="page-link"
//                                                             href="#"
//                                                             onClick={() => handlePageClick(currentPage - 1)}
//                                                         >
//                                                             Previous
//                                                         </a>
//                                                     </li>
//                                                     {[...Array(totalPages)].map((_, index) => (
//                                                         <li
//                                                             key={index + 1}
//                                                             className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}
//                                                         >
//                                                             <a
//                                                                 className="page-link"
//                                                                 href="#"
//                                                                 onClick={() => handlePageClick(index + 1)}
//                                                             >
//                                                                 {index + 1}
//                                                             </a>
//                                                         </li>
//                                                     ))}
//                                                     <li
//                                                         className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}
//                                                     >
//                                                         <a
//                                                             className="page-link"
//                                                             href="#"
//                                                             onClick={() => handlePageClick(currentPage + 1)}
//                                                         >
//                                                             Next
//                                                         </a>
//                                                     </li>
//                                                 </ul>
//                                             </nav>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default ProductCategory;




// import React, { useEffect, useState } from 'react';
// import '../Sidebar/Sidebar.css';
// import Sidebar from '../Sidebar/Sidebar';
// import Header from '../Header/Header';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import '@fortawesome/fontawesome-free/css/all.min.css';
// import axios from 'axios';
// import './PC.css';

// const ProductCategory = () => {
//     const [categoryName, setCategoryName] = useState('');
//     const [categories, setCategories] = useState([]);
//     const [entriesPerPage, setEntriesPerPage] = useState(5); // Set to 5 entries per page
//     const [searchTerm, setSearchTerm] = useState('');
//     const [loading, setLoading] = useState(true);
//     const [message, setMessage] = useState(null);
//     const [error, setError] = useState(null);
//     const [currentPage, setCurrentPage] = useState(1); // Track the current page
//     const [showModal, setShowModal] = useState(false); // Track modal visibility
//     const [editCategoryId, setEditCategoryId] = useState(null); // Track the category ID being edited
//     const [editCategoryName, setEditCategoryName] = useState(''); // Track the category name for editing

//     const fetchCategory = async () => {
//         try {
//             const response = await axios.get('https://posapi.emedha.in/api/category');
//             setCategories(response.data);
//             setLoading(false);
//         } catch (err) {
//             setError('Error fetching categories');
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchCategory();
//     }, []);

//     const handleCategoryChange = (event) => {
//         setCategoryName(event.target.value);
//     };

//     const handleSearchChange = (event) => {
//         setSearchTerm(event.target.value);
//     };

//     const filteredCategories = categories.filter((category) =>
//         category.cat_name && category.cat_name.trim().toLowerCase().includes(searchTerm.toLowerCase())
//     );

//     const totalPages = Math.ceil(filteredCategories.length / entriesPerPage);

//     const currentCategories = filteredCategories.slice(
//         (currentPage - 1) * entriesPerPage,
//         currentPage * entriesPerPage
//     );

//     const handlePageClick = (pageNumber) => {
//         setCurrentPage(pageNumber);
//     };

//     const handleSubmit = async (event) => {
//         event.preventDefault();

//         if (!categoryName.trim()) {
//             alert('Category name is required');
//             return;
//         }

//         try {
         
//             const response = await axios.post('https://posapi.emedha.in/api/post/category', {
//                 cat_name: categoryName.trim(),
//             });

      
//             setMessage(response.data.message); 
//             setCategoryName('');
//             fetchCategory()
//         } catch (err) {
//             console.error('Error adding category:', err);
//             setError('Error adding category'); 
//         }
//     };

//     const handleDelete = async (catId) => {
//         try {
//             const response = await axios.delete(`https://posapi.emedha.in/api/delete/category/${catId}`);
//             alert(response.data.message);  
//             fetchCategory();  
//         } catch (err) {
//             alert('Error deleting category');
//             console.error(err);
//         }
//     };

//     const handleUpdate = async (catId, updatedCategoryName) => {
//         try {
//             const response = await axios.put(`https://posapi.emedha.in/api/update/category/${catId}`, {
//                 cat_name: updatedCategoryName,
//             });
//             alert(response.data.message);  
//             fetchCategory();  
//             setShowModal(false);  
//         } catch (err) {
//             alert('Error updating category');
//             console.error(err);
//         }
//     };

//     const openEditModal = (catId, catName) => {
//         setEditCategoryId(catId);
//         setEditCategoryName(catName);
//         setShowModal(true);
//     };

//     const closeEditModal = () => {
//         setShowModal(false);
//         setEditCategoryId(null);
//         setEditCategoryName('');
//     };

//     return (
//         <>
//             <Sidebar />
//             <div id="main">
//                 <div className="container mt-4">
//                     <div className="row">
                    
//                         <div className="col-md-4">
//                             <div className="card">
//                                 <div className="card-header">Category Name</div>
//                                 <div className="card-body">
//                                     <form onSubmit={handleSubmit}>
//                                         <div className="floating-label-container">
//                                             <input
//                                                 type="text"
//                                                 className="floating-input"
//                                                 id="categoryName"
//                                                 value={categoryName}
//                                                 onChange={handleCategoryChange}
//                                                 placeholder=" "
//                                             />
//                                             <label htmlFor="categoryName" className="floating-label">
//                                                 Enter Category
//                                             </label>
//                                         </div>
//                                         <button type="submit" className="btn btn-primary">
//                                             Submit
//                                         </button>
//                                     </form>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="col-md-8">
//                             <div className="card">
//                                 <div className="card-header">Category List</div>
//                                 <div className="card-body">
//                                     <div className="row mb-3">
//                                         <div className="col-md-6">
//                                             <label>
//                                                 Show
//                                                 <select
//                                                     className="custom-select custom-select-sm form-control form-control-sm"
//                                                     style={{ width: 'auto', display: 'inline-block' }}
//                                                     value={entriesPerPage}
//                                                     onChange={(e) => setEntriesPerPage(Number(e.target.value))}
//                                                 >
//                                                     <option value="5">5</option>
//                                                     <option value="10">10</option>
//                                                     <option value="25">25</option>
//                                                     <option value="50">50</option>
//                                                 </select>
//                                                 entries
//                                             </label>
//                                         </div>
//                                         <div className="col-md-6 text-right">
//                                             <label>
//                                                 Search:
//                                                 <input
//                                                     type="search"
//                                                     className="form-control form-control-sm"
//                                                     value={searchTerm}
//                                                     onChange={handleSearchChange}
//                                                 />
//                                             </label>
//                                         </div>
//                                     </div>

//                                     <table className="table table-bordered table-hover">
//                                         <thead>
//                                             <tr>
//                                                 <th>No</th>
//                                                 <th>Category Name</th>
//                                                 <th>Action</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {currentCategories.map((category, index) => (
//                                                 <tr key={category.cat_id}>
//                                                     <td>{(currentPage - 1) * entriesPerPage + index + 1}</td>
//                                                     <td>{category.cat_name}</td>
//                                                     <td>
//                                                         <button
//                                                             className="btn btn-info btn-sm"
//                                                             onClick={() => openEditModal(category.cat_id, category.cat_name)}
//                                                         >
//                                                             <i className="fas fa-edit"></i>
//                                                         </button>
//                                                         <button
//                                                             className="btn btn-danger btn-sm ml-2"
//                                                             onClick={() => handleDelete(category.cat_id)}
//                                                         >
//                                                             <i className="fas fa-trash"></i>
//                                                         </button>
//                                                     </td>
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>

//                                     <div className="row">
//                                         <div className="col-md-6">
//                                             <p>
//                                                 Showing {(currentPage - 1) * entriesPerPage + 1} to{' '}{Math.min(currentPage * entriesPerPage, filteredCategories.length)} of {filteredCategories.length} entries
//                                             </p>
//                                         </div>
//                                         <div className="col-md-6">
//                                             <nav>
//                                                 <ul className="pagination">
//                                                     <li
//                                                         className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}
//                                                     >
//                                                         <a
//                                                             className="page-link"
//                                                             href="#"
//                                                             onClick={() => handlePageClick(currentPage - 1)}
//                                                         >
//                                                             Previous
//                                                         </a>
//                                                     </li>
//                                                     {[...Array(totalPages)].map((_, index) => (
//                                                         <li
//                                                             key={index + 1}
//                                                             className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}
//                                                         >
//                                                             <a
//                                                                 className="page-link"
//                                                                 href="#"
//                                                                 onClick={() => handlePageClick(index + 1)}
//                                                             >
//                                                                 {index + 1}
//                                                             </a>
//                                                         </li>
//                                                     ))}
//                                                     <li
//                                                         className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}
//                                                     >
//                                                         <a
//                                                             className="page-link"
//                                                             href="#"
//                                                             onClick={() => handlePageClick(currentPage + 1)}
//                                                         >
//                                                             Next
//                                                         </a>
//                                                     </li>
//                                                 </ul>
//                                             </nav>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {showModal && (
//                 <div className="modal fade show" style={{ display: 'block' }} onClick={closeEditModal}>
//                     <div className="modal-dialog" onClick={(e) => e.stopPropagation()}> {/* Stop propagation here */}
//                         <div className="modal-content">
//                             <div className="modal-header">
//                                 <h5 className="modal-title">Edit Category</h5>
//                                 <button
//                                     type="button"
//                                     className="close"
//                                     onClick={closeEditModal}
//                                 >
//                                     <span>&times;</span>
//                                 </button>
//                             </div>
//                             <div className="modal-body">
//                                 <div className="form-group">
//                                     <label>Category Name</label>
//                                     <input
//                                         type="text"
//                                         className="form-control"
//                                         value={editCategoryName}
//                                         onChange={(e) => setEditCategoryName(e.target.value)}
//                                     />
//                                 </div>
//                             </div>
//                             <div className="modal-footer">
//                                 <button
//                                     type="button"
//                                     className="btn btn-secondary"
//                                     onClick={closeEditModal}
//                                 >
//                                     Close
//                                 </button>
//                                 <button
//                                     type="button"
//                                     className="btn btn-primary"
//                                     onClick={() => handleUpdate(editCategoryId, editCategoryName)}
//                                 >
//                                     Save changes
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//         </>
//     );
// };

// export default ProductCategory;



import React, { useEffect, useState } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import Header from '../Header/Header';
import axios from 'axios';

const Icons = {
  Plus: (size = 16) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="5" x2="12" y2="19"></line>
      <line x1="5" y1="12" x2="19" y2="12"></line>
    </svg>
  ),
  Search: (size = 16) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
  ),
  Edit2: (size = 14) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
    </svg>
  ),
  Trash2: (size = 14) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="3 6 5 6 21 6"></polyline>
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
      <line x1="10" y1="11" x2="10" y2="17"></line>
      <line x1="14" y1="11" x2="14" y2="17"></line>
    </svg>
  )
};

const ProductCategory = () => {
  const [categoryName, setCategoryName] = useState('');
  const [categories, setCategories] = useState([]);
  const [entriesPerPage, setEntriesPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editCategoryId, setEditCategoryId] = useState(null);
  const [editCategoryName, setEditCategoryName] = useState('');
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const fetchCategory = async () => {
    setLoading(true);
    try {
      const response = await axios.get('https://posapi.emedha.in/api/category');
      setCategories(response.data || []);
    } catch (err) {
      console.error('Error fetching categories:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategory();
  }, []);

  const filteredCategories = categories.filter((category) =>
    category.cat_name && category.cat_name.trim().toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredCategories.length / entriesPerPage) || 1;
  const currentCategories = filteredCategories.slice(
    (currentPage - 1) * entriesPerPage,
    currentPage * entriesPerPage
  );

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    if (!categoryName.trim()) {
      alert('Category name is required');
      return;
    }
    try {
      const response = await axios.post('https://posapi.emedha.in/api/post/category', {
        cat_name: categoryName.trim(),
      });
      alert(response.data.message || 'Category added successfully');
      setCategoryName('');
      setShowAddModal(false);
      fetchCategory();
    } catch (err) {
      alert('Error adding category');
    }
  };

  const handleDelete = async (catId) => {
    if (!window.confirm('Are you sure you want to delete this category?')) return;
    try {
      const response = await axios.delete(`https://posapi.emedha.in/api/delete/category/${catId}`);
      alert(response.data.message || 'Category deleted successfully');
      fetchCategory();
    } catch (err) {
      alert('Error deleting category');
    }
  };

  const handleUpdate = async (catId, updatedCategoryName) => {
    if (!updatedCategoryName.trim()) {
      alert('Category name cannot be empty');
      return;
    }
    try {
      const response = await axios.put(`https://posapi.emedha.in/api/update/category/${catId}`, {
        cat_name: updatedCategoryName.trim(),
      });
      alert(response.data.message || 'Category updated successfully');
      fetchCategory();
      setShowModal(false);
    } catch (err) {
      alert('Error updating category');
    }
  };

  // Function to generate the smart page range (e.g. 1 2 3 4 ... 342 343 344 345)
const getPaginationItems = () => {
  if (totalPages <= 8) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  // If current page is in the beginning
  if (currentPage <= 4) {
    return [1, 2, 3, 4, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
  }

  // If current page is in the end
  if (currentPage >= totalPages - 3) {
    return [1, 2, 3, 4, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
  }

  // If current page is somewhere in the middle
  return [
    1,
    '...',
    currentPage - 1,
    currentPage,
    currentPage + 1,
    '...',
    totalPages
  ];
};

  return (
    <div 
    // style={{ display: 'flex', width: '100vw', minHeight: '100vh', backgroundColor: '#fcfaf8' }}
    
    >
      <Sidebar />

      {/* Main Content Area filling entire available remaining space */}
      <div
       // id="main"
        // style={{
        //   flex: 1,
        //   width: '100%',
        //   display: 'flex',
        //   flexDirection: 'column',
        //   minWidth: 0,
        //   boxSizing: 'border-box'
        // }}
      >

        <div
          style={{
            flex: 1,
            width: '100%',
            padding: isMobile ? '16px' : '24px 32px',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px'
          }}
        >
          {/* Header Bar */}
          <div
            style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              alignItems: isMobile ? 'flex-start' : 'center',
              justifyContent: 'space-between',
              gap: '16px',
              width: '100%'
            }}
          >
            <div>
              <h2
                style={{
                  margin: 0,
                  fontSize: isMobile ? '22px' : '26px',
                  fontWeight: '700',
                  color: '#111827',
                  fontFamily: "'Cinzel', serif"
                }}
              >
                Product Categories
              </h2>
              <p style={{ margin: '4px 0 0 0', fontSize: '14px', color: '#6b7280' }}>
                {categories.length} categories listed
              </p>
            </div>

            <button
              onClick={() => setShowAddModal(true)}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                padding: '10px 20px',
                borderRadius: '12px',
                fontSize: '14px',
                fontWeight: '600',
                color: '#ffffff',
                background: 'linear-gradient(135deg, #f97316, #c2410c)',
                boxShadow: '0 4px 16px rgba(249, 115, 22, 0.3)',
                border: 'none',
                cursor: 'pointer',
                width: isMobile ? '100%' : 'auto'
              }}
            >
              {Icons.Plus(16)}
              <span>Add Category</span>
            </button>
          </div>

          {/* Controls Bar: Search & Page Limit */}
          <div
            style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              justifyContent: 'space-between',
              alignItems: isMobile ? 'stretch' : 'center',
              gap: '12px',
              width: '100%'
            }}
          >
            <div style={{ position: 'relative', flex: 1, maxWidth: isMobile ? '100%' : '420px' }}>
              <span
                style={{
                  position: 'absolute',
                  left: '14px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#9ca3af',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                {Icons.Search(16)}
              </span>
              <input
                type="search"
                placeholder="Search categories…"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
                style={{
                  width: '100%',
                  padding: '11px 16px 11px 40px',
                  borderRadius: '12px',
                  border: '1px solid #e5e7eb',
                  fontSize: '14px',
                  outline: 'none',
                  backgroundColor: '#fdf8f3',
                  color: '#1f2937',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: '#4b5563' }}>
              <span>Show</span>
              <select
                value={entriesPerPage}
                onChange={(e) => {
                  setEntriesPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
                style={{
                  padding: '8px 12px',
                  borderRadius: '10px',
                  border: '1px solid #e5e7eb',
                  fontSize: '14px',
                  backgroundColor: '#ffffff',
                  color: '#1f2937',
                  outline: 'none',
                  cursor: 'pointer'
                }}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
              </select>
              <span>entries</span>
            </div>
          </div>

          {/* Table Container */}
          {loading ? (
            <div style={{ textAlign: 'center', padding: '50px 0', color: '#6b7280', fontSize: '14px' }}>
              Loading categories...
            </div>
          ) : (
            <>
              <div
                style={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #ffedd5',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                  width: '100%',
                  overflow: 'hidden'
                }}
              >
                <div style={{ width: '100%', overflowX: 'auto' }}>
                  <table
                    style={{
                      width: '100%',
                      borderCollapse: 'collapse',
                      textAlign: 'left',
                      tableLayout: 'fixed'
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          backgroundColor: 'rgba(255, 247, 237, 0.6)',
                          borderBottom: '1px solid #ffedd5',
                          fontSize: '12px',
                          fontWeight: '600',
                          color: '#374151',
                          textTransform: 'uppercase',
                          letterSpacing: '0.05em'
                        }}
                      >
                        <th style={{ padding: '14px 20px', width: '70px' }}>No</th>
                        <th style={{ padding: '14px 20px' }}>Category Name</th>
                        <th style={{ padding: '14px 20px', textAlign: 'right', width: '110px' }}>Action</th>
                      </tr>
                    </thead>
                    <tbody style={{ fontSize: '14px' }}>
                      {currentCategories.length > 0 ? (
                        currentCategories.map((category, index) => {
                          const serialNumber = (currentPage - 1) * entriesPerPage + index + 1;
                          return (
                            <tr
                              key={category.cat_id}
                              style={{
                                borderBottom: '1px solid #fff7ed',
                                backgroundColor: '#ffffff'
                              }}
                            >
                              <td style={{ padding: '16px 20px', color: '#6b7280', fontWeight: '500' }}>
                                {serialNumber}
                              </td>
                              <td style={{ padding: '16px 20px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                  <div
                                    style={{
                                      width: '36px',
                                      height: '36px',
                                      borderRadius: '10px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      backgroundColor: '#fff7ed',
                                      fontSize: '16px',
                                      flexShrink: 0
                                    }}
                                  >
                                    📁
                                  </div>
                                  <span
                                    style={{
                                      fontWeight: '600',
                                      color: '#111827',
                                      wordBreak: 'break-word',
                                      overflowWrap: 'break-word'
                                    }}
                                  >
                                    {category.cat_name}
                                  </span>
                                </div>
                              </td>
                              <td style={{ padding: '16px 20px', textAlign: 'right' }}>
                                <div style={{ display: 'inline-flex', gap: '8px', justifyContent: 'flex-end' }}>
                                  <button
                                    onClick={() => {
                                      setEditCategoryId(category.cat_id);
                                      setEditCategoryName(category.cat_name);
                                      setShowModal(true);
                                    }}
                                    title="Edit Category"
                                    style={{
                                      width: '34px',
                                      height: '34px',
                                      borderRadius: '8px',
                                      backgroundColor: '#fff7ed',
                                      color: '#ea580c',
                                      border: 'none',
                                      cursor: 'pointer',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}
                                  >
                                    {Icons.Edit2(14)}
                                  </button>
                                  <button
                                    onClick={() => handleDelete(category.cat_id)}
                                    title="Delete Category"
                                    style={{
                                      width: '34px',
                                      height: '34px',
                                      borderRadius: '8px',
                                      backgroundColor: '#fef2f2',
                                      color: '#ef4444',
                                      border: 'none',
                                      cursor: 'pointer',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}
                                  >
                                    {Icons.Trash2(14)}
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td
                            colSpan={3}
                            style={{
                              textAlign: 'center',
                              padding: '36px 0',
                              color: '#9ca3af',
                              fontSize: '14px'
                            }}
                          >
                            No categories found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Pagination Controls */}
              {/* {totalPages > 1 && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '12px',
                    paddingTop: '8px',
                    width: '100%'
                  }}
                >
                  <p style={{ margin: 0, fontSize: '13px', color: '#6b7280' }}>
                    Showing {(currentPage - 1) * entriesPerPage + 1} to{' '}
                    {Math.min(currentPage * entriesPerPage, filteredCategories.length)} of {filteredCategories.length} entries
                  </p>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <button
                      onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                      disabled={currentPage === 1}
                      style={{
                        padding: '6px 14px',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb',
                        fontSize: '12px',
                        fontWeight: '500',
                        color: '#4b5563',
                        backgroundColor: '#ffffff',
                        cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                        opacity: currentPage === 1 ? 0.4 : 1
                      }}
                    >
                      Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                      <button
                        key={page}
                        onClick={() => setCurrentPage(page)}
                        style={{
                          width: '32px',
                          height: '32px',
                          borderRadius: '8px',
                          fontSize: '12px',
                          fontWeight: '500',
                          cursor: 'pointer',
                          border: currentPage === page ? 'none' : '1px solid #e5e7eb',
                          backgroundColor: currentPage === page ? '#f97316' : '#ffffff',
                          color: currentPage === page ? '#ffffff' : '#4b5563'
                        }}
                      >
                        {page}
                      </button>
                    ))}
                    <button
                      onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
                      disabled={currentPage === totalPages}
                      style={{
                        padding: '6px 14px',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb',
                        fontSize: '12px',
                        fontWeight: '500',
                        color: '#4b5563',
                        backgroundColor: '#ffffff',
                        cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                        opacity: currentPage === totalPages ? 0.4 : 1
                      }}
                    >
                      Next
                    </button>
                  </div>
                </div>
              )} */}

              {/* Pagination Controls */}
{totalPages > 1 && (
  <div
    style={{
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '12px',
      paddingTop: '12px',
      width: '100%',
      flexWrap: 'wrap'
    }}
  >
    <p style={{ margin: 0, fontSize: '13px', color: '#6b7280' }}>
      Showing {(currentPage - 1) * entriesPerPage + 1} to{' '}
      {Math.min(currentPage * entriesPerPage, filteredCategories.length)} of {filteredCategories.length} entries
    </p>

    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flexWrap: 'wrap' }}>
      {/* First Page Button */}
      <button
        onClick={() => setCurrentPage(1)}
        disabled={currentPage === 1}
        title="First Page"
        style={{
          padding: '6px 10px',
          borderRadius: '8px',
          border: '1px solid #e5e7eb',
          fontSize: '12px',
          fontWeight: '500',
          color: '#4b5563',
          backgroundColor: '#ffffff',
          cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
          opacity: currentPage === 1 ? 0.4 : 1
        }}
      >
        « First
      </button>

      {/* Previous Button */}
      <button
        onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
        disabled={currentPage === 1}
        title="Previous Page"
        style={{
          padding: '6px 12px',
          borderRadius: '8px',
          border: '1px solid #e5e7eb',
          fontSize: '12px',
          fontWeight: '500',
          color: '#4b5563',
          backgroundColor: '#ffffff',
          cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
          opacity: currentPage === 1 ? 0.4 : 1
        }}
      >
        Prev
      </button>

      {/* Page Numbers & Ellipsis */}
      {getPaginationItems().map((item, index) => {
        if (item === '...') {
          return (
            <span
              key={`ellipsis-${index}`}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '28px',
                height: '32px',
                fontSize: '14px',
                color: '#9ca3af',
                userSelect: 'none'
              }}
            >
              ...
            </span>
          );
        }

        const isCurrent = currentPage === item;
        return (
          <button
            key={`page-${item}`}
            onClick={() => setCurrentPage(item)}
            style={{
              minWidth: '32px',
              height: '32px',
              padding: '0 6px',
              borderRadius: '8px',
              fontSize: '12px',
              fontWeight: isCurrent ? '700' : '500',
              cursor: 'pointer',
              border: isCurrent ? 'none' : '1px solid #e5e7eb',
              backgroundColor: isCurrent ? '#f97316' : '#ffffff',
              color: isCurrent ? '#ffffff' : '#4b5563',
              boxShadow: isCurrent ? '0 2px 8px rgba(249, 115, 22, 0.3)' : 'none',
              transition: 'all 0.15s ease'
            }}
          >
            {item}
          </button>
        );
      })}

      {/* Next Button */}
      <button
        onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
        disabled={currentPage === totalPages}
        title="Next Page"
        style={{
          padding: '6px 12px',
          borderRadius: '8px',
          border: '1px solid #e5e7eb',
          fontSize: '12px',
          fontWeight: '500',
          color: '#4b5563',
          backgroundColor: '#ffffff',
          cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
          opacity: currentPage === totalPages ? 0.4 : 1
        }}
      >
        Next
      </button>

      {/* Last Page Button */}
      <button
        onClick={() => setCurrentPage(totalPages)}
        disabled={currentPage === totalPages}
        title="Last Page"
        style={{
          padding: '6px 10px',
          borderRadius: '8px',
          border: '1px solid #e5e7eb',
          fontSize: '12px',
          fontWeight: '500',
          color: '#4b5563',
          backgroundColor: '#ffffff',
          cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
          opacity: currentPage === totalPages ? 0.4 : 1
        }}
      >
        Last »
      </button>
    </div>
  </div>
)}
            </>
          )}
        </div>
      </div>

      {/* Add Modal */}
      {showAddModal && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '16px',
            backgroundColor: 'rgba(0, 0, 0, 0.45)',
            backdropFilter: 'blur(2px)'
          }}
          onClick={() => setShowAddModal(false)}
        >
          <div
            style={{
              backgroundColor: '#ffffff',
              borderRadius: '16px',
              padding: '24px',
              width: '100%',
              maxWidth: '440px',
              boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
              boxSizing: 'border-box'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={{ margin: '0 0 16px 0', fontSize: '18px', fontWeight: '700', color: '#111827' }}>
              Add Category
            </h3>
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                  Category Name
                </label>
                <input
                  type="text"
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                  placeholder="e.g. Flowers & Garlands"
                  style={{
                    width: '100%',
                    padding: '10px 14px',
                    borderRadius: '10px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    outline: 'none',
                    backgroundColor: '#fdf8f3',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
              <div style={{ display: 'flex', gap: '12px', marginTop: '8px' }}>
                <button
                  type="button"
                  onClick={() => setShowAddModal(false)}
                  style={{
                    flex: 1,
                    padding: '10px 16px',
                    borderRadius: '10px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#4b5563',
                    backgroundColor: '#ffffff',
                    cursor: 'pointer'
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  style={{
                    flex: 1,
                    padding: '10px 16px',
                    borderRadius: '10px',
                    border: 'none',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#ffffff',
                    background: 'linear-gradient(135deg, #f97316, #c2410c)',
                    cursor: 'pointer'
                  }}
                >
                  Save Category
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {showModal && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '16px',
            backgroundColor: 'rgba(0, 0, 0, 0.45)',
            backdropFilter: 'blur(2px)'
          }}
          onClick={() => setShowModal(false)}
        >
          <div
            style={{
              backgroundColor: '#ffffff',
              borderRadius: '16px',
              padding: '24px',
              width: '100%',
              maxWidth: '440px',
              boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
              boxSizing: 'border-box'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={{ margin: '0 0 16px 0', fontSize: '18px', fontWeight: '700', color: '#111827' }}>
              Edit Category
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                  Category Name
                </label>
                <input
                  type="text"
                  value={editCategoryName}
                  onChange={(e) => setEditCategoryName(e.target.value)}
                  placeholder="Enter category name"
                  style={{
                    width: '100%',
                    padding: '10px 14px',
                    borderRadius: '10px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    outline: 'none',
                    backgroundColor: '#fdf8f3',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
            </div>
            <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
              <button
                type="button"
                onClick={() => setShowModal(false)}
                style={{
                  flex: 1,
                  padding: '10px 16px',
                  borderRadius: '10px',
                  border: '1px solid #e5e7eb',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#4b5563',
                  backgroundColor: '#ffffff',
                  cursor: 'pointer'
                }}
              >
                Close
              </button>
              <button
                type="button"
                onClick={() => handleUpdate(editCategoryId, editCategoryName)}
                style={{
                  flex: 1,
                  padding: '10px 16px',
                  borderRadius: '10px',
                  border: 'none',
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#ffffff',
                  background: 'linear-gradient(135deg, #f97316, #c2410c)',
                  cursor: 'pointer'
                }}
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductCategory;